import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Sobre o Instituto', path: '/sobre' },
    { name: 'Nossos Programas', path: '/programas' },
    { name: 'Mercado de Trabalho', path: '/mercado-trabalho' },
    { name: 'Agenda de Eventos', path: '/agenda' }
  ];

  const programs = [
    { name: 'Despertar', path: '/programas#despertar' },
    { name: 'Capacita', path: '/programas#capacita' },
    { name: 'Geração Valor', path: '/programas#geracao-valor' },
    { name: 'Mentorias', path: '/programas#mentorias' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center">
                <i className="ri-graduation-cap-fill text-2xl text-slate-900"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: "'Pacifico', serif" }}>
                Allcance
              </h3>
            </div>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Transformando vidas através do desenvolvimento pessoal e profissional.
            </p>
            <p className="text-yellow-400 font-semibold text-lg">
              Allcance o futuro que quiser!
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-yellow-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-lg font-bold mb-4">Programas</h4>
            <ul className="space-y-3">
              {programs.map((program) => (
                <li key={program.path}>
                  <Link
                    to={program.path}
                    className="text-slate-400 hover:text-yellow-400 transition-colors cursor-pointer"
                  >
                    {program.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-yellow-400 text-xl mt-1"></i>
                <div>
                  <p className="text-slate-400">Telefone</p>
                  <a href="tel:+5511999999999" className="text-white hover:text-yellow-400 transition-colors cursor-pointer">
                    (11) 99999-9999
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-yellow-400 text-xl mt-1"></i>
                <div>
                  <p className="text-slate-400">E-mail</p>
                  <a href="mailto:contato@institutoallcance.com.br" className="text-white hover:text-yellow-400 transition-colors cursor-pointer">
                    contato@institutoallcance.com.br
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-yellow-400 text-xl mt-1"></i>
                <div>
                  <p className="text-slate-400">Endereço</p>
                  <p className="text-white">São Paulo, SP</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media */}
        <div className="border-t border-slate-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
            <Link
              to="/inscricoes"
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-slate-900 px-8 py-3 rounded-full font-bold hover:from-yellow-500 hover:to-yellow-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Quero ser aluno
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 pt-8 text-center text-slate-400">
          <p>
            © {currentYear} Instituto Allcance. Todos os direitos reservados. |{' '}
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
